import AboutUsOurStory from "./AboutUsOurStory";
import AboutUsOurVision from "./AboutUsOurVision";
import AboutUsOurMission from "./AboutUsOurMission";
import AboutUsOurPurpose from "./AboutUsOurPurpose";
import AboutUsOurValues from "./AboutUsOurValues";
import Contact from "./Contact" 
import { Container, Row } from "react-bootstrap";
// import useFetch from "./useFetch";
import "../style/Home.css"

const Home = () => {

  return (
    <Container fluid>
      <Row  className="Home subsection">
        <AboutUsOurStory></AboutUsOurStory>
      </Row>
      <Row className="Home subsection">
        <AboutUsOurVision></AboutUsOurVision>
      </Row>
      <Row className="Home subsection">
        <AboutUsOurMission></AboutUsOurMission>
      </Row>
      <Row className="Home subsection">
        <AboutUsOurPurpose></AboutUsOurPurpose>
      </Row>
      <Row className="Home subsection">
        <AboutUsOurValues></AboutUsOurValues>
      </Row>
      <Row className="Home">
        <Contact></Contact>
      </Row>
    </Container>
  );
}
 
export default Home;
